import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SHIFT_ID } from '../loads/loads-routing.constants';
import { PublicShiftTimelineComponent } from '../loads/public-shift-timeline/public-shift-timeline.component';
import { CertificationsPermitsComponent } from './certifications-permits/certifications-permits.component';
import { CompletedLoadsForDriverComponent } from './driver-details/completed-loads/completed-loads-for-driver.component';
import { DriverDetailsComponent } from './driver-details/driver-details.component';
import { ProfileComponent } from './driver-details/profile/profile.component';
import { SafetyComponent } from './driver-details/safety/safety.component';
import { ScorecardComponent } from './driver-details/scorecard/scorecard.component';
import { DRIVER_ID } from './driver-routing.constants';
import { DriversListComponent } from './drivers-list/drivers-list.component';
import { InviteAdminComponent } from './invite-admin/invite-admin.component';
import { InviteDriverComponent } from './invite-driver/invite-driver.component';
import { Invite5fTourDriverComponent } from './invite-tour-driver/invite-tour-driver.component';

const routes: Routes = [
  {
    path: 'list',
    component: DriversListComponent,
  },
  {
    path: 'invite_driver',
    component: InviteDriverComponent,
  },
  {
    path: 'invite_admin',
    component: InviteAdminComponent,
  },
  {
    path: 'invite_tour_driver',
    component: Invite5fTourDriverComponent,
  },
  {
    path: `:${DRIVER_ID}/timeline/:${SHIFT_ID}`,
    component: PublicShiftTimelineComponent,
  },
  {
    path: `:${DRIVER_ID}`,
    component: DriverDetailsComponent,
    children: [
      {
        path: `scorecard`,
        component: ScorecardComponent,
      },
      {
        path: `completed`,
        component: CompletedLoadsForDriverComponent,
      },
      {
        path: `profile`,
        component: ProfileComponent,
      },
      {
        path: `certifications`,
        component: CertificationsPermitsComponent,
      },
      {
        path: `safety`,
        component: SafetyComponent,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'scorecard',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'list',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DriversRoutingModule {}
